import { fg } from '@atlaskit/platform-feature-flags';
import { initialPreferencesAreMissing } from '../../controllers/cookie-controls/transformer';
import { checkIfTokenIsDefault } from '../../services/consent-hub-service/utils';
import { PrefetchedPreferenceState } from '../../types';
export var shouldShowBannerInSSRContext = function shouldShowBannerInSSRContext(initialPreferences) {
  if (fg('platform_moonjelly_bsc_ssr_killswitch')) {
    // If our bsc ssr killswitch is enabled, we should not show the banner
    // in SSR context
    return false;
  }
  if (initialPreferences === PrefetchedPreferenceState.INTERNAL) {
    // If we're in the "fetch internally" state, we have no prefetched data and we can't determine
    // if the user has consented or not yet since we need to fetch, so show the banner
    return true;
  }
  if (!initialPreferences || initialPreferencesAreMissing(initialPreferences)) {
    // No data at all, we need to fetch again, but hide on this pass
    return false;
  }
  // If prefetched data has a consentToken or the consents array is there and populated
  // we want to hide the banner, as the user has has made consents already.
  var prefetchedToken = 'consentToken' in initialPreferences && initialPreferences.consentToken;
  var prefetchedTokenIsDefault = checkIfTokenIsDefault(prefetchedToken || '');
  var hasLegitConsentToken = prefetchedToken && !prefetchedTokenIsDefault;
  var prefetchedConsents = 'consents' in initialPreferences && initialPreferences.consents;
  var hasLegitConsents = prefetchedConsents && prefetchedConsents.length > 0;
  var prefetchedDataHasConsents = Boolean(hasLegitConsentToken || hasLegitConsents);
  var showBannerSinceUserHasNotConsented = !prefetchedDataHasConsents;
  return showBannerSinceUserHasNotConsented;
};